export const metricasService = {
    captureIP: async () => {
        try {
            //verificar si hay datos en cache y no estan expirados
            const cachedData = localStorage.getItem("Griftin_getoData");
            if(cachedData){
                const {data, timestamp} = JSON.parse(cachedData);
                const ONE_MONTH = 1000 * 60 * 60 * 24 * 30;
                if(Date.now() - timestamp < ONE_MONTH){
                    return data;
                }
            }

            const apiGeolocationKey = "c3650321db8a403bb1c67aa9f73f36af";
            let respuesta = ""

            console.log("%c INICIO DE LA PETICION A IPIFY","color: blue");

            const res = await fetch('https://api.ipify.org?format=json');
            const data = await res.json();
            

            if(data.ip){
                const info = await fetch(`https://api.ipgeolocation.io/ipgeo?apiKey=${apiGeolocationKey}&ip=${data.ip}`)
                respuesta = await info.json();

                //gudardar datos en cache
                localStorage.setItem("Griftin_getoData", JSON.stringify({
                    data: respuesta,
                    timestamp: Date.now()
                }));
                
            }else{
                throw new Error("No se pudo obtener la IP");
            }

            return respuesta;
          } catch (err) {
            console.error('Error al obtener la IP:', err);
          }
    }

}